// extracted by mini-css-extract-plugin
export default {"linkText":"Linkify_linkText__bPyHb"};